export const moduleId = 'deviceRegistry'